import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import NavbarComponent from 'components/Navbar/Navbar.jsx'
import actions from 'actions'
import { retrieveLinks } from 'services/navLinks';
import constants from 'constants';

const {
  logout,
  showModal
} = actions;

const {
  MODAL_TYPE_NAVBAR
} = constants;


class Navbar extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      logged,
      role,
      showMobileNav,
      logout,
      user
    } = this.props;
    return (
      <NavbarComponent
        links={retrieveLinks({
          logged, role, user
        })}
        logoutAction={logged ? logout : null}
        {...{user, showMobileNav}}
      />
    )
  }
}

Navbar.PropTypes = {
  logged: PropTypes.boolean
}

function mapStateToProps(state) {
  return {
    logged: !!(state.users.user && state.session && state.session.token),
    role: state.users.user.role,
    user: state.users.user
  };
}

const mapDispatchToProps = (dispatch) => (
  {
    logout: () => dispatch(logout()),
    showMobileNav: () => dispatch(showModal(MODAL_TYPE_NAVBAR))
  }
)

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);



/** WEBPACK FOOTER **
 ** ./src/containers/Navbar/Navbar.js
 **/